function Gametitle(props) {
    return (
      <div className="titleblock" onClick={() => props.ontitleclick()}>
        <span className="gametitle">{props.title}</span>
        <span className="gamesubtitle2">Show Info</span>
      </div>
    );
  }
  
  export default Gametitle;